import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import Select from "react-select";
import { toast } from "react-toastify";
import BranchesService from "../../../../../services/Company/BranchesService";
import ScrollPagination from "../../../../common/ScrollPagination";

const AddDepartmentModal = ({
	addModal,
	setAddModal,
	item,
	setShouldUpdate,
	Service,
}) => {
	const [formData, setFormData] = useState({
		name: "",
		branchId: "",
	});
	const [isAdd, setIsAdd] = useState(false);
	const [loading, setLoading] = useState(false);
	const lang = useSelector((state) => state.auth.lang);

	useEffect(() => {
		if (Object.keys(item)?.length === 0) {
			setIsAdd(true);
		} else {
			setIsAdd(false);
			setFormData({
				id: item?.id,
				name: item?.name,
				branchId: {
					label: item?.breanch?.names[lang],
					value: item?.breanch?.id,
				},
			});
		}
	}, [item]);

	const submit = (e) => {
		e.preventDefault();
		let data = {
			name: formData?.name,
			branchId: formData?.branchId?.value,
		};

		setLoading(true);
		if (isAdd) {
			Service.create(data)
				?.then((res) => {
					if (res && res?.status === 201) {
						toast.success(`Department Added Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		} else {
			Service.update(formData?.id, data)
				?.then((res) => {
					if (res && res?.status === 200) {
						toast.success(`Department Updated Successfully`);
						setShouldUpdate((prev) => !prev);
						setAddModal();
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	};

	return (
		<Modal
			className={
				lang === "en" ? "en fade addDepartment" : "ar fade addDepartment"
			}
			style={{ textAlign: lang === "en" ? "left" : "right" }}
			show={addModal}
			onHide={() => setAddModal()}>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Modal.Body>
					<Row>
						<Col md={12} className="mb-2">
							<div className="d-flex justify-content-between">
								<p
									className="mb-0"
									style={{
										fontWeight: "600",
										color: "#000",
										fontSize: "22px",
									}}>
									{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
									{Translate[lang]?.department}
								</p>
								<Button
									variant=""
									className="close"
									style={{
										right: lang === "en" ? "0" : "auto",
										left: lang === "ar" ? "0" : "auto",
									}}
									onClick={() => {
										setAddModal();
									}}>
									<span style={{ fontSize: "22px" }}>&times;</span>
								</Button>
							</div>
						</Col>
						<Col md={12}>
							<label className="text-label">{Translate[lang]?.branch}</label>
							<ScrollPagination
								Service={new BranchesService()}
								value={formData?.branchId}
								nameVal="name"
								setData={(e) =>
									setFormData((prev) => ({ ...prev, branchId: e }))
								}
							/>
						</Col>
						{/* Name */}
						<Col md={12}>
							<AvField
								label={Translate[lang]?.name}
								type="text"
								placeholder={Translate[lang]?.name}
								bsSize="lg"
								name="name"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target.value })
								}
							/>
						</Col>
					</Row>
				</Modal.Body>
				<Modal.Footer>
					<Button
						variant="primary"
						type="submit"
						className="w-100"
						disabled={loading}>
						{isAdd ? Translate[lang]?.add : Translate[lang]?.edit}{" "}
						{Translate[lang]?.department}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Modal>
	);
};

export default AddDepartmentModal;
